import React, { BaseSyntheticEvent } from 'react'
import { IonItem, IonLabel, IonList, IonToggle } from '@ionic/react'
import './PNNVList.component.css'
import { IOption, IOptions, IPNNVOption } from '../../common/common.types'

interface IPNVListProps {
  options: IOptions
  selectedOption: IPNNVOption | null
  onSelection: (option: any) => void
  handleClearNormalValues?: () => void
  showToggle?: boolean
  nemsis?: string
}

const PNNVList: React.FC<IPNVListProps> = ({
  options,
  selectedOption,
  onSelection,
  handleClearNormalValues = null,
  showToggle = false,
  nemsis = 'nemsisCode',
}) => {
  const handleOnSelect = (e: BaseSyntheticEvent, option: IOption) => {
    e.preventDefault()
    if (e.target.checked) {
      selectOption(option)
    } else {
      onSelection(null)
    }
  }

  const selectOption = (option: IOption) => {
    if (option.name) {
      const obj = {
        id: option.id,
        name: option.name,
        pn: '',
        nv: '',
      }
      const key = nemsis as keyof IOption
      if (option[key]) {
        if (option.isPN) {
          obj.pn = String(option[key])
        } else if (option.isNV) {
          obj.nv = String(option[key])
        }
      }
      if (handleClearNormalValues) handleClearNormalValues()
      onSelection(obj as IPNNVOption)
    }
  }

  return (
    <IonList lines='inset'>
      {options?.map((option: IOption) => (
        <IonItem
          key={option.id}
          data-testid={`Option_${option.id}`}
          className={`${selectedOption?.id === option.id ? 'selected-pnnv-option' : ''} pnnv-option`}
          {...(!showToggle && { onClick: () => selectOption(option) })}>
          <IonLabel id={`optionLabel_${option.id}`}>{option.name}</IonLabel>
          {showToggle && (
            <IonToggle
              slot='start'
              name={option.name}
              value={`${option.id}`}
              disabled={!!selectedOption && selectedOption?.id !== option.id}
              checked={selectedOption?.id === option.id}
              onClick={(e) => handleOnSelect(e, option)}
            />
          )}
        </IonItem>
      ))}
    </IonList>
  )
}

export default PNNVList
